import { FC } from 'react';

import { SvgIconProps } from 'types/styles';
import { SvgIcon } from 'ui/SvgIcon';

export const ArrowDownIcon: FC<SvgIconProps> = (props) => (
  <SvgIcon
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      opacity="1"
      d="M12.4287 6C12.6655 6 12.8574 6.19401 12.8574 6.43333V15.114L16.6643 11.2573C16.7448 11.1753 16.8543 11.1292 16.9686 11.1292C17.0829 11.1292 17.1925 11.1753 17.273 11.2573L17.8732 11.8727C17.9544 11.954 18 12.0648 18 12.1803C18 12.2959 17.9544 12.4066 17.8732 12.488L12.6173 17.8093C12.4968 17.9313 12.3334 17.9998 12.1629 18H11.8371C11.667 17.998 11.5042 17.9297 11.3827 17.8093L6.12681 12.488C6.04565 12.4066 6 12.2959 6 12.1803C6 12.0648 6.04565 11.954 6.12681 11.8727L6.73556 11.2573C6.81458 11.1758 6.92274 11.1299 7.03565 11.1299C7.14856 11.1299 7.25672 11.1758 7.33574 11.2573L11.1426 15.114V6.43333C11.1426 6.19401 11.3345 6 11.5713 6H12.4287Z"
      fill="currentColor"
    />
  </SvgIcon>
);
